import React from "react";
// import { Progress } from "semantic-ui-react";
import useTheme from "../../hooks/useTheme";
import AppText from "../UI/Texts/AppTexts";
import { AppColumn, AppRow } from "./Layouts";
import { SizedBox } from "./Sizes";

const RateProgressBar = ({ total, title, average}) => {
  const theme = useTheme();
  const progressPercentage = (average / total) * 100;

  return (
    <div style={{ width: `100%` }}>
      <AppColumn>
        <AppRow mainAxisAlignment={'space-between'}>
          <AppText.FootnoteSmall>{title}</AppText.FootnoteSmall>
          <AppText.FootnoteSmall> {average.toFixed(2)}</AppText.FootnoteSmall>
        </AppRow>
        <SizedBox height={theme.spacing.elementPaddingSmall} />
        <Progress
          percent={progressPercentage}
          size="tiny"
          style={{
            backgroundColor: theme.colors.lightGrey,
          }}
        />
        <SizedBox height={theme.spacing.elementPadding} />
      </AppColumn>
    </div>
  );
};

export default RateProgressBar;



const Progress = ({ percent, height = 10 }) => {
  const theme = useTheme();
  return (
    <div
      style={{
        width: "100%",
        backgroundColor: theme.colors.lightGrey,
        borderRadius: `999px`,
        overflow: "hidden",
        height: `${height}px`,
      }}
    >
      <div
        style={{
          width: `${percent}%`,
          backgroundColor: theme.primaryColor,
          borderRadius: `999px`,
          height: "100%",
          transition: "width 0.3s ease-in-out",
        }}
      />
    </div>
  );
};
